import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import { ReactElement, useEffect, useState } from 'react'
import { useEffectOnce } from 'usehooks-ts'
import styled from 'styled-components'
import { GlobalVariables } from 'Globals/GlobalVariables'
import { dataButter } from './butter'
import { dataApfelüberrest } from './apfelüberrest'
import { dataHeidelbeere } from './heidelbeere'
import { dataKuss } from './kuss'
import { dataLöwenzahn } from './löwenzahn'
import { dataPfütze } from './pfütze'
import { dataSchluckauf } from './schluckauf'
import { dataSchmetterling } from './schmetterling'
import { dataSofa } from './sofa'
import MapStepper from 'components/MapStepper'
import './fullwidth.scss'

const MainComponent = ({
  tenant,
  colorMode,
  properties,
}: MicroFrontendProps) => {
  const [isMobile, setIsMobile] = useState(false)
  const modules: { [key: string]: ReactElement } = {
    header: <div>header</div>,
    scrollytelling: (
      <>
        <p>above</p>
        <p>above</p>
        <p>above</p>
        <p>above</p>
        <p>above</p>
        <p>above</p>
        <p>above</p>
        <p>above</p>
        <p>above</p>
        <p>above</p>
        <p>above</p>
        <p>above</p>
        <p>above</p>
        <p>above</p>
        <p>above</p>
        <p>above</p>
        <p>above</p>
        <p>above</p>
        <p>above</p>
        <p>above</p>
        <p>above</p>
        <p>above</p>
        <p>above</p>
        <p>above</p>

        <div>
          <MapStepper data={dataButter} colorMode={colorMode} />
        </div>
        <div>
          <MapStepper data={dataSchmetterling} colorMode={colorMode} />
        </div>
        <div>
          <MapStepper data={dataPfütze} colorMode={colorMode} />
        </div>
        <div>
          <MapStepper data={dataSofa} colorMode={colorMode} />
        </div>

        <div>
          <MapStepper data={dataLöwenzahn} colorMode={colorMode} />
        </div>
        <div>
          <MapStepper data={dataSchluckauf} colorMode={colorMode} />
        </div>
        <div>
          <MapStepper data={dataKuss} colorMode={colorMode} />
        </div>

        <p>below</p>
        <p>below</p>
        <p>below</p>
        <p>below</p>
        <p>below</p>
        <p>below</p>
        <p>below</p>
        <p>below</p>
        <p>below</p>
        <p>below</p>
        <p>below</p>
        <p>below</p>
        <p>below</p>
        <p>below</p>
        <p>below</p>
        <p>below</p>
        <p>below</p>
        <p>below</p>
        <p>below</p>
        <p>below</p>
        <p>below</p>
        <p>below</p>
        <p>below</p>
        <p>below</p>
      </>
    ),
    butter: (
      <div>
        <MapStepper data={dataButter} colorMode={colorMode} />
      </div>
    ),
    apfelüberrest: (
      <div>
        <MapStepper data={dataApfelüberrest} colorMode={colorMode} />
      </div>
    ),
    heidelbeere: (
      <div>
        <MapStepper data={dataHeidelbeere} colorMode={colorMode} />
      </div>
    ),
    löwenzahn: (
      <div>
        <MapStepper data={dataLöwenzahn} colorMode={colorMode} />
      </div>
    ),
    kuss: (
      <div>
        <MapStepper data={dataKuss} colorMode={colorMode} />
      </div>
    ),
    pfütze: (
      <div>
        <MapStepper data={dataPfütze} colorMode={colorMode} />
      </div>
    ),
    schluckauf: (
      <div>
        <MapStepper data={dataSchluckauf} colorMode={colorMode} />
      </div>
    ),
    schmetterling: (
      <div>
        <MapStepper data={dataSchmetterling} colorMode={colorMode} />
      </div>
    ),
    sofa: (
      <div>
        <MapStepper data={dataSofa} colorMode={colorMode} />
      </div>
    ),
  }
  const handleResize = (): void => {
    setIsMobile(window.innerWidth < 711)
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  useEffectOnce(() => {
    // const htmlElement = document.documentElement
    // htmlElement.style.setProperty('scroll-snap-type', 'y proximity')
  })

  return (
    <AppContainer $colorMode={colorMode}>
      {modules[properties.module]}
    </AppContainer>
  )
}
const AppContainer = styled(TamediaStyles)`${GlobalVariables}
  font-family: var(--font-sans-serif);
  font-size: 1.8rem;
  line-height: 3rem;

  .front {
    z-index: -1;
    opacity: 0;
  }
`
export default MainComponent
